<template lang='pug' src='./navigation.pug'></template>

<script>
import NavigationDesktop from './navigation-desktop/navigation-desktop'

export default {
  computed: {
    props () {
      return this.$store.state.app
    },
    links () {
      return this.$router.options.routes
    }
  },
  components: {
    NavigationDesktop
  }
}
</script>



// WEBPACK FOOTER //
// navigation.vue?4206790d